<template>
    <v-container>
        <v-row>
            <v-col>Область для подписания стилусом:</v-col>
            <v-spacer />
            <v-col class="text-right">
                <v-btn @click="clear" color="gray" rounded outlined>Очистить</v-btn>
            </v-col>
        </v-row>
        <VueSignaturePad id="signature" width="100%" height="224px" :custom-style="customStyle" ref="signaturePad" :options="options" />
    </v-container>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    name: 'StylusSign',
    data: function() {
        return {
            sign_data: null,
            customStyle: {
                border: '#ccc 1px solid'
            },
            options: {
                penColor: 'black',
                onBegin: () => {
                    this.$refs.signaturePad.resizeCanvas();
                }
            }
        };
    },
    computed: {
        ...mapActions('sign', ['postStylusSign'])
    },
    methods: {
        undo() {
            this.$refs.signaturePad.undoSignature();
        },
        clear() {
            this.$refs.signaturePad.clearSignature();
        },
        dataURIToBlob(dataURI) {
            const splitDataURI = dataURI.split(',');
            const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1]);
            const mimeString = splitDataURI[0].split(':')[1].split(';')[0];

            const ia = new Uint8Array(byteString.length);
            for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);

            return new Blob([ia], { type: mimeString });
        }
    }
};
</script>

<style>
#signature {
    background-image: linear-gradient(white, white);
    background-origin: border-box;
    background-clip: content-box, border-box;
}
</style>
